import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import Register from "./components/Register";
import Quiz from "./components/Quiz";
import Dashboard from "./components/Dashboard";
import BackgroundAudio from "./components/BackgroundAudio";
import Rules from "./components/Rules";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <Router>
      <BackgroundAudio />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/register" element={<Register />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/leaderboard" element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
